<template>
      <div class="staffRequirementEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'staffRequirement', params: {} }">
          Staff Requirement
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'staffRequirementEdit', params:{id: id} }">
            Edit Staff Requirement
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Staff Requirement</v-card-title>
          <v-card-text>
            <staffRequirement-form :id="id"></staffRequirement-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import StaffRequirementForm from './StaffRequirementForm.vue';

    export default {
      name: 'staffRequirement',
      data () {
        return {
          id: null
        }
      },
      components: {
        StaffRequirementForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    